import React, { useState, useEffect } from "react";
import PageHeader from "../../../common/components/PageHeader/PageHeader";
import ChallengeBlock from '../../../common/components/ChallengeBlock/ChallengeBlock';
import { Container } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useChallenge } from '../../../hooks/useChallenge';

const styles = theme => ({
  container: {
    flexGrow: 1,
    marginTop: -130,
    position: 'relative',
    paddingBottom: 50
  },
  TwoColumn: {
    maxWidth: 1150,
  },
  OneColumn: {
    maxWidth: 980,
  }
});

const ChallengeTemplate = (props) => {
  const [submitting, setSubmitting] = useState(props.isSubmitting);
  // Inizializziamo step a null per aspettare i dati dal backend
  const [step, setStep] = useState(null);

  useEffect(() => {
    setSubmitting(props.isSubmitting);
  }, [props.isSubmitting]);

  useEffect(() => {
    setStep(+props.currentStep);
  }, [props.currentStep]);

  var parameter = "param";
  var questionField = "";
  
  // Sostituiamo useQuery di GraphQL con useChallenge
  const {
    data,
    isLoading: loading,
    error
  } = useChallenge(props.type);


  if (loading || step === null) return ""; // Aspetta sia i dati che l'inizializzazione dello step
  if (error) return `Error! ${error.message}`;
  if (!data || !data.challengeDefinition)
    return <div>No Challenge description</div>;
  
  // Non serve più JSON.parse, useChallenge restituisce già l'oggetto
  const challenge = data.challengeDefinition;
  
  // Merge SOLO dello status dinamico (blockedSteps viene dalla challenge definition, non dalla instance!)
  const enhancedChallenge = {
    ...challenge,
    status: props.challengeStatus  // ← Status dinamico da AppraiseResult
    
  };
  
  const {
    classes
  } = props;

  function onChange(parameter1, value) {
    parameter = value;
    questionField = value;
    return true;
  }

  async function submit(value, stepTime, status, response = null, goNext = true, isValidationAction = false, isRevokeAction = false) {
    if (!submitting){
      // Se abbiamo una risposta (file), aggiornala nel questionField
      if (response) {
        questionField = response; // ← Il file diventa la risposta alla domanda
        parameter = response.name || "file_upload"; 
      }
      
      // Aspetta che la submit vada a buon fine prima di avanzare
      await props.submit(parameter, questionField, enhancedChallenge, stepTime, status, isValidationAction, isRevokeAction);
      
      // Avanza SOLO se la chiamata è andata a buon fine E goNext è true
      if (step + 1 < value && goNext) {
        setStep(step + 1);
      }
    }
  }

  const hasMedia =
    enhancedChallenge.steps[step].imageLink ||
    enhancedChallenge.steps[step].videoLink
  ;
  const hasCarousel = enhancedChallenge.steps[step].imageCarousel;

  return (
    <>
      <PageHeader data={{ 'challengeTitle': enhancedChallenge.challengeTitle }} />
      <Container
        className={classes.container}
        classes={{ maxWidthLg: hasMedia ? classes.TwoColumn : classes.OneColumn }}
      >
        <ChallengeBlock
          challenge={enhancedChallenge}
          history={props.history}
          onSubmit={submit} 
          onChanged={onChange}
          stepIndex={step}
          hasMedia={hasMedia}
          hasCarousel={hasCarousel}
          onSkipStep={() => setStep(step + 1)} // ← Continua a gestire skip nel frontend
          isSubmitting={submitting}
        />
      </Container>
    </>
  );
}

export default withStyles(styles)(ChallengeTemplate);
